import {
  AbstractService
} from "./abstract.service";

import axios from 'axios'

export class PackageService extends AbstractService {

  static get VUE_APP_NPA_API() {
    return process.env.VUE_APP_NPA_API;
  }

  static get VUE_APP_GATEWAY_API_URL(){
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static get MERCHANT_INFOR() {
    return JSON.parse(localStorage.getItem("auth.currentMerchant"))
  }

  static async checkMerchantHasPlan() {
    try {
      const response = await await this.callApi().get(
        `${this.VUE_APP_NPA_API}/api/order/check-merchant-has-plan?merchantId=${this.MERCHANT_INFOR.id}`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getActivePlan(params) {
    try {
      const response = await await this.callApi().get(
        `${this.VUE_APP_NPA_API}/api/plan/get-active-plan?appId=${process.env.VUE_APP_ID}&isNotIncludeFree=${params.isNotIncludeFree}`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createOrder(params) {
    try {
      const response = await await this.callApi().post(
        `${this.VUE_APP_NPA_API}/api/order/save`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getActivePlanV2(params) {
    try {
      const response = await axios.get(
        `${this.VUE_APP_NPA_API}/api/plan/get-active-plan?appId=${process.env.VUE_APP_ID}&isNotIncludeFree=${params.isNotIncludeFree}`
      )
      return response.data
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async merchantPlanConfigs() {
    try {
      const response = await await this.callApi().get(
        `${this.VUE_APP_GATEWAY_API_URL}/nsh/main/api/merchant-policy-configs`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async merchantPlanConfigsCreate(params) {
    try {
      const response = await this.callApi().post(
        `${this.VUE_APP_GATEWAY_API_URL}/nsh/main/api/merchant-policy-configs`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async merchantPlanConfigsUpdate(params) {
    try {
      const response = await this.callApi().put(
        `${this.VUE_APP_GATEWAY_API_URL}/nsh/main/api/merchant-policy-configs`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async checkMerchantHasAllowing(key) {
    try {
      const response = await this.callApi().get(
        `${this.VUE_APP_GATEWAY_API_URL}/nsh/main/api/merchant-policy-configs/${key}`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}